/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletGroupIcon16Light = forwardRef('TextBulletGroupIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4Zm3 0H3v2h2V4Z" }),
        React.createElement("path", { d: "M8 3a.5.5 0 0 0 0 1h5.5a.5.5 0 0 0 0-1H8Z" }),
        React.createElement("path", { d: "M7.5 6.5A.5.5 0 0 1 8 6h5.5a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M8 9a.5.5 0 0 0 0 1h5.5a.5.5 0 0 0 0-1H8Z" }),
        React.createElement("path", { d: "M8 12a.5.5 0 0 0 0 1h5.5a.5.5 0 0 0 0-1H8Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3Zm0 1h2v2H3v-2Z" })));
});
